import { Row } from "antd";
import React from "react";
import { withRouter } from "../../../../utils/tms-with-router/tms-with-router";
const TmsReportProtocolReport = () => {
  return <Row>Protocol Reports</Row>;
};

export default withRouter(TmsReportProtocolReport);
